import { setToken } from '@/utils/token'

const isProd = Object.is(process.env.NODE_ENV, 'production')

if (!isProd) {
  setToken()
}
